<canvas baseChart
        *ngIf="inputData"
        [data]="doughnutChartData"
        [type]="doughnutChartType"
        [options]="doughnutChartOptions"
        height="91"
        width="91">
</canvas>
